import img101 from "../images/resource/subjects/mgimg_heart.jpg";

import titleImg1 from "../images/resource/subjects/gsimg_gs.jpg";
import titleImg2 from "../images/title/veterinarian-doctor-examining-dog-dachshund-wire-c-2022-09-28-22-19-18-utc.jpg";
import titleImg3 from "../images/resource/subjects/DSC06707.jpg";
import titleImg4 from "../images/resource/images/스카이MRI실.jpeg";
import titleImg5 from "../images/resource/subjects/안과.png";
import titleImg6 from "../images/resource/subjects/dental.png";
import sec3img11 from "../images/bp/처치.jpg";
import sec3img12 from "../images/bp/수술실_02.jpg";
import sec3img13 from "../images/bp/회의.jpg";
import sec3img21 from "../images/resource/subjects/equip/재활의학센터/고압산소 챔버.jpg";
import sec3img22 from "../images/bp/차트.jpeg";
import sec3img23 from "../images/bp/처치.jpg";
import sec3img31 from "../images/bp/진료.jpg";
import sec3img32 from "../images/bp/약제실.jpg";
import sec3img33 from "../images/bp/영상판독.png";
import sec3img41 from "../images/resource/subjects/equip/영상의학센터/GE Signa HDxt 1.5T.jpg";
import sec3img42 from "../images/bp/초음파실_2.jpg";
import sec3img43 from "../images/bp/영상판독.png";
import sec3img51 from "../images/bp/백내장장비.png";
import sec3img52 from "../images/bp/안과장비.png";
import sec3img53 from "../images/bp/현미경_01.jpg";
import sec3img61 from "../images/resource/subjects/denimg_1.jpg";
import sec3img62 from "../images/bp/수술실_02.jpg";
import sec3img63 from "../images/resource/subjects/emeimg_1.jpg";

import equip1 from "../images/resource/subjects/equip/외과센터/GENORAY C-ARM OSCAR PRIME.jpg"; // 외과
import equip2 from "../images/resource/subjects/equip/외과센터/STRYKER SONOPET.jpg"; // 외과
import equip3 from "../images/resource/subjects/equip/외과센터/GE 9100c NXT.jpg"; // 외과
import equip4 from "../images/resource/subjects/equip/외과센터/OLYMPUS THUNDERBEAT .png"; // 외과
import equip5 from "../images/resource/subjects/equip/외과센터/Carl Zeiss S4.jpg"; // 외과
import equip61 from "../images/resource/subjects/equip/외과센터/Autoclave.jpg"; // 외과
import equip62 from "../images/resource/subjects/equip/외과센터/EO gas.jpg"; // 외과
import equip63 from "../images/resource/subjects/equip/외과센터/저온Plasma.jpg"; // 외과
import equip7 from "../images/resource/subjects/equip/재활의학센터/고압산소 챔버.jpg"; // 재활
import equip8 from "../images/resource/subjects/equip/재활의학센터/P1 Diode laser.jpg"; // 재활
import equip9 from "../images/resource/subjects/equip/재활의학센터/수중 런닝머신 .jpg"; // 재활
import equip10 from "../images/resource/subjects/equip/재활의학센터/전침 물리치료.jpg"; // 재활
import equip11 from "../images/resource/subjects/equip/내과진료센터/OLYMPUS 내시경.jpg"; // 내과
import equip12 from "../images/resource/subjects/equip/내과진료센터/PORTABLE 내시경.jpg"; // 내과
import equip131 from "../images/resource/subjects/equip/내과진료센터/혈액검사 장비.jpg"; // 내과 (혈액검사 장비 6개)
import equip132 from "../images/resource/subjects/equip/내과진료센터/CBC 혈구분석기.jpg"; // 내과 (혈액검사 장비 6개)
import equip133 from "../images/resource/subjects/equip/내과진료센터/DRI-CHEM NX600V_호르몬 분석장비.jpg"; // 내과 (혈액검사 장비 6개)
import equip134 from "../images/resource/subjects/equip/내과진료센터/FUJI DRI-CHEM NX600i_생화학분석기.jpg"; // 내과 (혈액검사 장비 6개)
import equip135 from "../images/resource/subjects/equip/내과진료센터/PT10V_혈액검사기기.jpg"; // 내과 (혈액검사 장비 6개)
import equip136 from "../images/resource/subjects/equip/내과진료센터/v200_호르몬 검사 기기.jpg"; // 내과 (혈액검사 장비 6개)
import equip14 from "../images/resource/subjects/equip/영상의학센터/GE Signa HDxt 1.5T.jpg"; // 영상
import equip15 from "../images/resource/subjects/equip/영상의학센터/GE Revolution ACT.jpg"; // 영상
import equip16 from "../images/resource/subjects/equip/영상의학센터/GE vivid S60.jpg"; // 영상
import equip17 from "../images/resource/subjects/equip/영상의학센터/GE LOGIQ V5 Expert.jpg"; // 영상
import equip18 from "../images/resource/subjects/equip/영상의학센터/VETTER-DX9 x-ray.jpg"; // 영상
import equip19 from "../images/resource/subjects/equip/안과센터/UMI 220 Slit lamp.jpg"; // 안과
import equip20 from "../images/resource/subjects/equip/안과센터/Bausch & Lomb Stellaris.jpg"; // 안과
import equip21 from "../images/resource/subjects/equip/안과센터/Zeiss S4.jpg"; // 안과
import equip22 from "../images/resource/subjects/equip/치과센터/Remex-K100 portable x-ray.jpg"; // 치과
import equip23 from "../images/resource/subjects/equip/치과센터/Rioscanjpg.jpg"; // 치과
import equip24 from "../images/resource/subjects/equip/치과센터/Dental unit.jpg"; // 치과

// import surgery1 from "../images/resource/subjects/surgery_01.jpeg";

const centerInfo = [
  {
    id: 1,
    titleImg: titleImg1,
    vetMemberIdx: [1, 4, 21],
    title: "외과센터",
    enTitle: "Advanced Surgery Center",
    subTitle: `대학병원급 최첨단 진단 장비
마취과 담당의 근무
지역병원 MRI, CT 의뢰`,
    sec2: [
      {
        title1: "안전한 수술, 성공적인 치료",
        title2: "SKY 외과센터",
        description: `반려동물의 건강과 행복을 위해 최선을 다하는 전문 외과팀이 수술을 담당하고 있습니다.

외과팀 수의사들은 석사 및 박사 학위를 소지한 전공의들로 구성되어 있으며, 풍부한 임상 경험을 통한 종합적이고 안정적인 수술을 진행하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img11,
        title: "외과 전공 수의사의 집도",
        enTitle: "",
        content: `석사, 박사 학위를 소지한 수의사의 대학병원 및 대형병원 근무 경력을 바탕으로 다양한 수술 케이스를 집도하고 있습니다. 반려동물에게 가장 적합한 치료, 수술 방법을 고민하고 안정적이며 효과적인 수술을 위해 노력하고 있습니다.`,
      },
      {
        img: sec3img12,
        title: "진단-수술-재활까지 One-stop",
        enTitle: "",
        content: `2017년, 인천 최초로 MRI 도입 이후 CT/MRI를 통한 진단, 정형/신경외과 수술의 풍부한 경험, 수술 이후 재활까지 One-stop 치료를 제공하고 있습니다. 복합 골절, 경추/흉요추 디스크 질환, 선천적 신경계 이상 등 다양한 고난이도 수술을 진행하고 있습니다.`,
      },
      {
        img: sec3img13,
        title: "전문적인 과별 연계 진료",
        enTitle: "",
        content: `정형/신경외과 외 일반외과, 흉부외과 등 모든 과별 수술을 진행하고 있으며 내과/영상의학과와의 효율적인 연계 진료를 통해 환자의 회복에 최선을 다하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip1,
        name: "GENORAY C-ARM OSCAR PRIM",
        description:
          "첨단 c-arm 시스템으로, 높은 화질의 이미지를 제공하여 정확한 수술을 진행할 수 있도록 해줍니다. 최소한의 방사선 노출로 안전한 진료환경을 제공합니다.",
      },
      {
        img: equip2,
        name: "STRYKER SONOPET",
        description:
          "초음파 기반의 수술 장비로 정형/신경/일반외과 수술에서 모두 사용할 수 있습니다. 정밀한 조직 제거, 적은 출혈량으로 빠른 회복을 도와줍니다. 외과 수술의 안정성과 효율성을 높여주는 수술 장비입니다.",
      },
      {
        img: equip3,
        name: "GE 9100c NXT",
        description:
          "정밀한 마취 가스 전달, 정확한 모니터링, 마취 중 발생할 수 있는 위험 요소를 최소화하기 위한 안전 장치가 장점인 호흡 마취기로 마취과정의 안전성과 효율성을 높여주는 장비입니다.",
      },
      {
        img: equip4,
        name: "OLYMPUS THUNDERBEAT",
        description:
          "초음파와 전기 에너지를 통해 절개와 봉합이 동시에 가능하므로 수술 시간을 단축할 수 있습니다. 정상 조직에 가해지는 손상이 적어 수술 후 회복을 빠르게 도와주며 합병증 발생 가능성을 줄일 수 있습니다.",
      },
      {
        img: equip5,
        name: "Carl Zeiss S4",
        description:
          "미세수술용 현미경으로 신경외과, 안과 수술 등에서 사용됩니다. 고해상도와 명확한 3D 시야를 제공하여 세밀한 구조를 확인할 수 있습니다. 수술의 정확성을 높이고, 환자의 안정성을 극대화하는 데 도움을 주는 장비입니다.",
      },
      {
        img: equip61,
        name: "Autoclave",
        description:
          "수술실에서 사용되는 기구와 도구들을 멸균하여 감염을 예방하는데 중요한 역할을 합니다. 멸균기는 환자와 의료진의 안전을 보장하고 감염을 예방하며, 수술의 성공률을 높여주는 반드시 필요한 장비입니다.",
      },
      {
        img: equip62,
        name: "EO gas",
        description:
          "수술실에서 사용되는 기구와 도구들을 멸균하여 감염을 예방하는데 중요한 역할을 합니다. 멸균기는 환자와 의료진의 안전을 보장하고 감염을 예방하며, 수술의 성공률을 높여주는 반드시 필요한 장비입니다.",
      },
      {
        img: equip63,
        name: "Plasma 멸균기",
        description:
          "수술실에서 사용되는 기구와 도구들을 멸균하여 감염을 예방하는데 중요한 역할을 합니다. 멸균기는 환자와 의료진의 안전을 보장하고 감염을 예방하며, 수술의 성공률을 높여주는 반드시 필요한 장비입니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "정밀하고 효과적인 수술",
      description: `최신 수술 장비와 숙련된 인력을 바탕으로 다양한 외과 수술을 전문적으로 진행하고 있습니다.

정밀하고 효과적인 수술을 진행하고 있으며 수술 중에도 지속적인 모니터링을 통해 안전을 최우선으로 고려하며, 수술 후 회복 과정까지 세심한 관리를 진행하고 있습니다.`,
    },
  },
  {
    id: 2,
    titleImg: titleImg2,
    vetMemberIdx: [],
    title: "재활의학센터",
    enTitle: "Rehabilitation Medicine Center",
    subTitle: `경험 많은 의료진의 수술집도
최신의 수술장비 및 마취장비 사용
최신의 멸균 시스템 적용`,
    sec2: [
      {
        title1: "더 나은 내일을 선사합니다",
        title2: "SKY 재활의학센터",
        description: `반려동물의 회복과 건강 증진을 위해 최신 치료 장비와 전문적인 재활 프로그램을 제공하고 있습니다.
반려동물의 움직임과 삶의 질을 높이는 것을 목표로 최선을 다하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img21,
        title: "최첨단 재활 장비",
        enTitle: "",
        content: `고압산소 챔버, 수중 런닝머신, 레이저 치료기 등 최신 장비를 활용해 반려동물의 재활과 회복을 돕습니다.`,
      },
      {
        img: sec3img22,
        title: "맞춤형 재활 프로그램",
        enTitle: "",
        content: `반려동물의 상태와 필요에 따른 맞춤형 재활 계획을 수립하여 최적의 회복을 돕습니다.`,
      },
      {
        img: sec3img23,
        title: "전문 의료진의 적합한 치료",
        enTitle: "",
        content: `반려동물의 상태를 모니터링하며, 치료 전반에 걸쳐 적절한 관리와 재활을 진행합니다. 안전한 치료를 통해 최상의 상태로 회복할 수 있도록 최선을 다합니다.`,
      },
    ],
    equip: [
      {
        img: equip7,
        name: "고압산소 챔버",
        description:
          "조직 회복을 촉진하고 염증을 줄여주며, 수술 후 회복을 돕는데 탁월한 효과를 보입니다. 피부, 염증, 수술부위 회복 및 신경 손상의 더 빠른 회복을 기대할 수 있습니다.",
      },
      {
        img: equip8,
        name: "P1 Diode laser",
        description:
          "통증 완화 및 염증 감소를 도와줍니다. 비침습적인 치료 방법으로 통증, 염증이 있는 부위에 국소적으로 적용하여 회복을 가속화 합니다. 뼈, 관절, 피부, 치과질환, 신경 등 다양한 분야에 활용 가능합니다.",
      },
      {
        img: equip9,
        name: "수중 런닝머신",
        description:
          "물의 부력과 저항을 활용한 수중 런닝머신을 통해, 관절에 부담을 최소화하면서 근력을 강화하고 효과적인 회복을 돕습니다. 관절염, 근골격계 질환을 앓고 있는 반려동물에게 적합한 치료 방법입니다.",
      },
      {
        img: equip10,
        name: "전침 물리치료",
        description:
          "전침 물리치료는 통증을 완화하고 근육을 이완시키는 데 효과적입니다. 신경계 질환이나 만성 통증 관리에 도움을 줍니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "건강한 회복, 재활의 힘으로 새로운 시작",
      description: `최첨단 치료 장비와 전문성을 바탕으로, 반려동물의 삶의 질을 높이는 맞춤형 재활 프로그램을 제공합니다.

고압산소 챔버부터 수중 런닝머신까지, 다양한 치료 옵션으로 빠르고 안전한 회복을 돕고 있습니다.`,
    },
  },
  {
    id: 3,
    titleImg: titleImg3,
    vetMemberIdx: [2, 3],
    title: "내과센터",
    enTitle: "Internal Medicine Center",
    subTitle: `24시간 icu 입원관리를 통한 중증환자집중치료
최신의 바이탈 모니터링 기계 사용한 환자상태 체크
경험많은 의료진의 협업을 통한 치료`,
    sec2: [
      {
        title1: "소중한 반려동물의 건강, 내과 센터와 함께",
        title2: "SKY 내과센터",
        description: `내과센터에서는 반려동물의 건강을 위한 전문적인 내과 진료를 제공하고 있습니다.

내분비, 심장, 신장 및 간 질환, 소화기, 호흡기 등 내과 질환을 세심하게 진료하고 있으며 종양 환자의 항암치료 역시 진행하고 있습니다.

풍부한 임상 경험과 전문성을 바탕으로 정확한 진단, 체계적인 치료를 통해 장기적인 건강을 위해 최선을 다하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img31,
        title: "다양한 내과 전문 진료",
        enTitle: "",
        content: `심장 질환, 내분비 질환, 신장 질환, 신경계 질환 등 복합적이고 만성적인 질환에 대해 전문적인 치료를 제공합니다. 정밀한 진단과 맞춤형 치료 계획을 통해 성공적인 치료를 위해 노력합니다.`,
      },
      {
        img: sec3img32,
        title: "노령 동물과 항암 치료 전문",
        enTitle: "",
        content: `노령 동물은 특별한 관리가 필요하며 질환을 예방하고 관리할 수 있는 프로그램을 운영합니다. 또한 항암 치료를 위한 최신 기술과 약물 치료로 반려동물의 삶의 질을 높이는 것을 목표로 하고 있습니다.`,
      },
      {
        img: sec3img33,
        title: "최신 진단 장비와 정밀 검사",
        enTitle: "",
        content: `내시경, 혈액검사 장비, CT/MRI 등 영상 진단 장비를 통한 정확한 진단하여 내과적 문제를 신속하게 파악하고, 최적의 치료 방법을 제공하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip11,
        name: "OLYMPUS 내시경",
        description:
          "식도, 위 등 소화기에서 발생할 수 있는 질병에 대한 진단 및 치료가 가능하고 이물 제거, 조직검사, 종양 절제 등 외과 수술 이전에 비침습적인 처치가 가능합니다.",
      },
      {
        img: equip12,
        name: "PORTABLE 내시경",
        description:
          "요도, 방광, 비강, 외이도, 기관지 등 육안적으로 확인하기 어려운 작은 구조물을 확인하고 진단, 생검, 절제 등 다양한 진료 분야에서 사용이 가능합니다.",
      },
      {
        img: equip131,
        name: "혈액검사 장비",
        description:
          "다양한 혈액검사 장비를 통한 빠르고 정확한 검사를 진행할 수 있으며 신속한 치료 계획을 수립할 수 있습니다.",
      },
      {
        img: equip132,
        name: "CBC 혈구분석기",
        description:
          "다양한 혈액검사 장비를 통한 빠르고 정확한 검사를 진행할 수 있으며 신속한 치료 계획을 수립할 수 있습니다.",
      },
      {
        img: equip133,
        name: "DRI-CHEM NX600V_호르몬 분석장비",
        description:
          "다양한 혈액검사 장비를 통한 빠르고 정확한 검사를 진행할 수 있으며 신속한 치료 계획을 수립할 수 있습니다.",
      },
      {
        img: equip134,
        name: "FUJI DRI-CHEM NX600i_생화학분석기",
        description:
          "다양한 혈액검사 장비를 통한 빠르고 정확한 검사를 진행할 수 있으며 신속한 치료 계획을 수립할 수 있습니다.",
      },
      {
        img: equip135,
        name: "PT10V_혈액검사기기",
        description:
          "다양한 혈액검사 장비를 통한 빠르고 정확한 검사를 진행할 수 있으며 신속한 치료 계획을 수립할 수 있습니다.",
      },
      {
        img: equip136,
        name: "v200_호르몬 검사 기기",
        description:
          "다양한 혈액검사 장비를 통한 빠르고 정확한 검사를 진행할 수 있으며 신속한 치료 계획을 수립할 수 있습니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "반려동물 내과 질환은 전문가의 영역입니다.",
      description: `말 못하는 반려동물의 특성 상 반려동물의 내과 질환은 초기에 발견되기 힘들고 진단 시에 이미 진행된 경우가 많습니다.

따라서 간단한 치료를 요하는 경우보다 엄격한 장기 관리, 입원관리를 요하는 경우가 많습니다. 여러가지 다양한 상황에 대한 고려가 필요하여 치료의 난이도가 높은 경우가 많습니다.

부평스카이동물의료센터는 다양한 케이스의 치료 경험을 바탕으로 능숙한 내과 전공자가 환자에게 최선의 치료를 제공하기 위해 노력하고 있습니다.`,
    },
  },
  {
    id: 4,
    titleImg: titleImg4,
    vetMemberIdx: [6, 7, 20],
    title: "영상의학센터",
    enTitle: "MRI & CT Center",
    subTitle: `24시간 icu 입원관리를 통한 중증환자집중치료
최신의 바이탈 모니터링 기계 사용한 환자상태 체크
경험많은 의료진의 협업을 통한 치료`,
    sec2: [
      {
        title1: "최첨단 영상으로 더 빠르고 정확한 진단",
        title2: "SKY 영상의학센터",
        description: `최첨단 장비와 전문 인력을 갖춘 영상의학센터는 운영하고 있으며 반려동물의 정확한 진단을 위해 최선을 다하고 있습니다.

모든 검사와 판독은 영상의학은 전공한 전공 수의사들이 진행하며, 높은 수준의 진단 결과를 바탕으로 최적의 치료 계획을 세울 수 있도록 노력하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img41,
        title: "1.5T MRI, 16ch CT",
        enTitle: "",
        content: `인천 최초로 MRI 도입 후 다양한 뇌, 척수, 신경계 진료 케이스를 검사한 경험을 바탕으로 정확하고 신속한 진단이 가능합니다.
        최신 CT 장비를 통해 뼈, 연부조직의 빠른 검사 및 마취 시간의 단축 등을 통해 환자의 빠른 회복을 돕고 있습니다.`,
      },
      {
        img: sec3img42,
        title: "심장, 복부 전용 초음파",
        enTitle: "",
        content: `심장, 복부 전용 초음파를 통해 심장 질환 및 소화기 질환 등 주요 장기 상태를 정확히 확인할 수 있습니다.
        비침습적이고 안전한 방법으로 심장, 간, 신장, 소화기 등 반려동물의 건강상태는 진단합니다.`,
      },
      {
        img: sec3img43,
        title: "안전한 마취와 전문적인 검사",
        enTitle: "",
        content: `마취가 필요한 MRI, CT 검사 시 고사양 호흡 마취기를 사용하고 있으며 숙련된 마취팀이 검사 전반에 걸쳐 모니터링합니다.
        영상의학 전공 수의사가 검사와 판독을 직접 진행하여, 더 정밀하고 신뢰도 높은 진단 결과를 제공합니다.
        `,
      },
    ],
    equip: [
      {
        img: equip14,
        name: "GE Signa HDxt 1.5T",
        description:
          "뛰어난 해상도의 MRI 영상을 제공하여 뇌, 척수, 관절 등 세밀한 부위에 대한 정확한 진단이 가능합니다. 고속 이미지 처리 기술로 검사 시간이 단축되어 빠른 마취 회복이 가능합니다.",
      },
      {
        img: equip15,
        name: "GE Revolution ACT",
        description:
          "방사선 노출을 최소화하면서 고해상도의 영상을 제공해 안전한 검사와 정확한 진단을 가능하게 합니다. 심혈관, 폐, 복부, 뼈 등 다양한 임상부위에서 활용 가능한 다목적 CT 장비입니다.",
      },
      {
        img: equip16,
        name: "GE vivid S60",
        description:
          "뛰어난 해상도와 심장 초음파 영상을 제공하며 더 세밀하고 정확한 심장 진단을 가능하게 합니다.",
      },
      {
        img: equip17,
        name: "GE LOGIQ V5 Expert",
        description:
          "다목적 초음파 장비로 복부, 근골격계 등 다양한 진료, 진단을 위해 사용되고 있습니다. 세밀한 병변까지도 정확하게 관찰할 수 있어 진단의 신뢰도를 높여줍니다.",
      },
      {
        img: equip18,
        name: "VETTER-DX9 x-ray",
        description:
          "방사선 노출을 최소화하는 장비로 촬영 후 이미지가 신속하게 처리되고 뛰어난 해상도의 이미지를 제공합니다. 영상 진단의 기본장비로 진료 전반적으로 다양한 정보를 얻는데 유용합니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "정밀하고 안전한 검사",
      description: `부평SKY동물의료센터는 2017년, 인천 최초로 MRI 장비를 도입한 이래 다양한 진료 케이스를 검사, 진단하고 치료 해왔습니다.

의료진의 풍부한 경험을 통한 정확하고 빠른 진단으로 반료동물의 건강을 지키기 위해 최선을 다하고 있습니다.`,
    },
  },
  {
    id: 5,
    titleImg: titleImg5,
    vetMemberIdx: [8],
    title: "안과센터",
    enTitle: "Ophthalmology Center",
    subTitle: `24시간 icu 입원관리를 통한 중증환자집중치료
최신의 바이탈 모니터링 기계 사용한 환자상태 체크
경험많은 의료진의 협업을 통한 치료`,
    sec2: [
      {
        title1: "맑은 눈을 지키는 최상의 안과 진료",
        title2: "SKY 안과센터",
        description: `부평SKY동물의료센터는 반려동물의 눈 건강을 전문적으로 관리하는 안과 센터를 운영하고 있습니다.

안과 전공 수의사가 검사, 진료, 수술을 담당하여 정확하게 진단하고 치료하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img51,
        title: "백내장 수술을 위한 최신 장비",
        enTitle: "",
        content: `백내장 수술을 위한 최신 장비를 갖추고 있어, 안전하고 정밀한 수술이 가능합니다. 반려동물의 시력을 회복시키고 삶의 질을 크게 향상 시킬 수 있습니다.`,
      },
      {
        img: sec3img52,
        title: "정확한 검사를 위한 장비",
        enTitle: "",
        content: `각막, 망막, 안구 내 구조를 정확히 진단할 수 있는 다양한 검사 장비를 보유하고 있으며 빠르고 정확한 진단이 가능합니다.`,
      },
      {
        img: sec3img53,
        title: "녹내장 및 다양한 안과 질환의 치료, 수술",
        enTitle: "",
        content: `녹내장과 같은 안압 문제를 효과적으로 관리하고 치료할 수 있는 최신 치료법을 적용하고 있으며 다양한 안과 질환의 수술을 진행하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip19,
        name: "UMI 220 Slit lamp",
        description:
          "각막, 수정체, 망막 등을 정밀하게 검사할 수 있습니다. 검사를 위한 특정 부위를 세밀하게 관찰할 수 있어 다양한 안과 질환을 조기 진단하고 정확하게 치료할 수 있습니다.",
      },
      {
        img: equip20,
        name: "Bausch & Lomb Stellaris",
        description:
          "초음파 에너지를 사용한 백내장 수술 장비로 안구 조직에 가해지는 손상을 최소화 하며, 수술 후 회복이 빠릅니다. 최소한의 에너지로 최대한의 효과를 내는 장비로 수술 시간이 단축되고 안정성이 높은 장점이 있습니다.",
      },
      {
        img: equip21,
        name: "Zeiss S4",
        description:
          "미세수술용 현미경으로 정밀하고 복잡한 안과 수술에 사용됩니다. 고해상도 시야를 제공해 수술의 정확성을 높이고, 환자의 안정성을 극대화하는 데 도움을 줍니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "반려동물의 소중하고 건강한 눈을 지킵니다.",
      description: `최신 장비와 풍부한 임상 경험을 바탕으로 반려동물의 눈 건강을 최우선으로 생각하며, 언제나 안전하고 효과적인 치료를 진행하고 있습니다.

      백내장, 녹내장, 각막, 안검 질환 등 다양한 안과 질환을 치료하고 있으며 정밀한 검사를 통한 환자 맞춤형 치료를 진행하고 있습니다.`,
    },
  },
  {
    id: 6,
    titleImg: titleImg6,
    vetMemberIdx: [8],
    title: "치과센터",
    enTitle: "Dental Center",
    subTitle: `24시간 icu 입원관리를 통한 중증환자집중치료
최신의 바이탈 모니터링 기계 사용한 환자상태 체크
경험많은 의료진의 협업을 통한 치료`,
    sec2: [
      {
        title1: "건강한 치아, 반려동물의 삶의 질을 높입니다",
        title2: "SKY 치과센터",
        description: `반려동물의 구강 건강을 위해 전문적인 치과 진료와 치료를 진행하고 있습니다.

치과 질환은 반려동물의 전반적인 건강에 영향을 미칠 수 있으므로 저희 부평SKY동물의료센터 치과 센터에서는 정확한 진단, 치료 및 정기적인 관리를 통해 건강한 구강 상태를 유지할 수 있도록 돕고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img61,
        title: "정확한 진단",
        enTitle: "",
        content: `구강 이상은 외부에서 쉽게 보이지 않을 수 있으므로 치과 전용 x-ray 및 CT를 통해 숨겨진 치주 질환, 치아 손상을 정확하게 진단, 치료하고 있습니다.`,
      },
      {
        img: sec3img62,
        title: "전문적인 수술 및 치료",
        enTitle: "",
        content: `치주 질환 치료, 치아 발치 등 다양한 치과 수술을 전문적으로 수행하며 최신 수술 장비와 기술을 사용하여 안전하고 효과적인 치료를 진행합니다.`,
      },
      {
        img: sec3img63,
        title: "안전한 마취 관리",
        enTitle: "",
        content: `치과 치료 및 수술 중에는 마취가 필수적입니다. 안전한 상태에서 수술이 진행될 수 있도록 고사양 호흡 마취기를 사용하고 철저한 모니터링을 진행하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip22,
        name: "Remex-K100 portable x-ray",
        description:
          "선명하고 정확한 x-ray 이미지를 제공하여 치아 및 주변 구조를 세밀하게 진단할 수 있습니다. 미세한 치주 질환이나 치아 손상 부위를 정확히 확인할 수 있습니다.",
      },
      {
        img: equip23,
        name: "Rioscan",
        description:
          "디지털 영상 기술로 x-ray 촬영 결과를 빠르게 확인할 수 있으며 고해상도 이미지를 얻을 수 있어 정확한 진단을 할 수 있습니다.",
      },
      {
        img: equip24,
        name: "Dental unit",
        description:
          "치과 수술 및 치료에 사용될 수 있는 다기능 장비로 발치, 치석 제거, 치주 치료 등 다양한 구강 문제를 해결하는 데 사용합니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "전문 치과 진료로 더 나은 삶을 선물합니다",
      description: `부평SKY동물의료센터 치과 센터에서는 스케일링, 발치, 치주 질환 등 다양한 치과 치료를 제공하며 구강 검사를 통해 질환을 조기 발견하고 적절한 치료를 신속하게 진행합니다.

치과 질환은 예방이 중요하기 때문에 정기적인 구강 관리를 통해 더 오래, 건강하게 지낼 수 있도록 노력하고 있습니다.`,
    },
  },
];

export default centerInfo;
